import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {CartItem} from '../../../../models/CartModels/cartItem';
import {CartService} from '../../../../services/cart.service';
import {Cart} from '../../../../models/CartModels/cart';
import {RegistryService} from '../../../../services/registry.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Product} from '../../../../models/product';

@Component({
    selector: 'app-numeric-updown',
    templateUrl: './numeric-updown.component.html',
    styleUrls: ['./numeric-updown.component.css']
})
export class NumericUpdownComponent implements OnInit {

    @Input('qty') qty = 0;
    @Input('item') item: CartItem;
    @Input('cart') cart: Cart;

    @ViewChild('updatebtn') updateBtn : ElementRef;


    constructor(private cartService: CartService , private registry: RegistryService, public snackBar: MatSnackBar) {
    }

    ngOnInit(): void {

    }

    NewValue(value) {

        if(this.item != undefined ) {

            let ctype = localStorage.getItem('customer_type');
            this.item.qty = value;
            let tempQty = this.qty;

            this.updateBtn.nativeElement.classList.add('fa-spin');
            this.cartService.updateCartItemQty(ctype, this.item, this.registry.Quote_id).subscribe(success => {


                this.updateBtn.nativeElement.classList.remove('fa-spin');
                this.cartService.EmitCartUpdated(this.cart);
                    this.cartService.EmitProductQtyUpdated(this.item);

                    this.cartService.checkOrderReady();
                    this.cartService.checkCartReady();

                }, failure => {
                    this.openSuccessSnackBar('This quantity is not available', ' OK');
                    this.qty = tempQty;
                    this.item.qty = tempQty;
                }
            )
        } else {
            this.qty = value ;
            this.cartService.EmitQtyUpdated(this.qty);

        }

    }


    // Snackbar that opens with success background
    openSuccessSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
            horizontalPosition: "right",
            panelClass: ['primary-snackbar'],
        });
    }


}
